'use strict';

import { Button, Card, Checkbox, Col, Form, Input, Row, Select, Tree } from 'antd';
import React from 'react';
import { PrmFactory, uuid, copy } from 'rt-sd-common';
import { checkOnChange, getSCModal, selectOnChange, textOnChange } from 'rt-sd-dnd/sgiDndDev/Dnd_SgiFormEditorCommon';
import { renderTreeNodes } from './common';
import { ctlTypes, formItemLayout, formItemLayout2, getEidtorFun, valueTypes } from './Constant';
const FormItem = Form.Item;
const TreeNode = Tree.TreeNode;
const Option = Select.Option;

const testStyle = {
    padding: 5,
    // border: '1px solid grey'
};

class ParamMngPrmDef extends React.Component {
    constructor(props) {
        super(props);

        let treeData = [];
        let guid;
        let prm;
        // let guids = guid.split("_");
        // let prm = PrmFactory.getPrm(guid);
        let _key = uuid(8);
        var detail = tool.parseForBrowserHistory(this.props);
        if (!detail.addFlag) {
            guid = detail.record.guid;
            prm = detail.record;
            _key = detail.record[_key] || _key;
        }
        if (!prm || !prm.te) {//getPrm会返回空对象，所以判断一下te
            prm = {
                n: "系统参数xxx",
                te: "系统参数xxx",
                _key: _key,
                ap: "Emos",
                tt: "param",
                ss: "",
                sc: "",
                nodeType: "prm"
            };
        }
        treeData.push(prm);

        this.state = {
            values: prm,
            selectedKeys: [_key],
            treeData: treeData,
            sysStore: [],
            nodeType: "prm",//节点类型
            SCModalVisible: false,
        };
    }

    addSub = (nodeType) => {
        let record = this.state.values;
        if (!record) {
            alert("请选择节点");
        }
        this.addCldSet(record, nodeType);
    }
    delNode = () => {
        let treeNode = this.state.treeNode || {};
        let dataRef = treeNode.props.dataRef;
        let parentDataRef = treeNode.props.parentDataRef;
        if (parentDataRef && dataRef) {
            let cldSet = parentDataRef.cldSet || [];
            cldSet.splice(cldSet.indexOf(dataRef), 1);
            this.setState({});
        }
    }
    copyNode = () => {
        let treeNode = this.state.treeNode || {};
        let dataRef = treeNode.props.dataRef;
        let parentDataRef = treeNode.props.parentDataRef;
        if (parentDataRef && dataRef) {
            let cldSet = parentDataRef.cldSet || [];
            let copyData = copy(dataRef, true);
            this.changeKeys(copyData);
            cldSet.splice(cldSet.indexOf(dataRef) + 1, 0, copyData);
            this.setState({});
        }
    }
    changeKeys = (item) => {
        item.te += "-copy";
        item._key = uuid(8);
        if (item.nodeType === "group") {
            item.sc = uuid(8);
        } else {
            item.id = uuid(64);
        }
        if (item.cldSet && item.cldSet.length > 0) item.cldSet.forEach(r => this.changeKeys(r));
    }
    save = () => {
        let prm = this.state.treeData[0];
        tool.sgiLogger.log("save prm:", prm);
        let result = PrmFactory.save(prm);
        if (result == 0) {
            tool.popMessage("保存成功！", "success");
        } else {
            tool.popMessage("保存失败，result：" + result, "warning");
        }
    }
    refresh(attname, value) {
        this.state.values[attname] = value;
        this.setState({ loading: false });
    }

    onDrop = info => {
        const dropKey = info.node.props.eventKey;
        const dragKey = info.dragNode.props.eventKey;
        const dropPos = info.node.props.pos.split('-');
        const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1]);

        const loop = (data, key, callback) => {
            data.forEach((item, index, arr) => {
                if (item._key === key) {
                    return callback(item, index, arr);
                }
                if (item.cldSet) {
                    return loop(item.cldSet, key, callback);
                }
            });
        };
        // const data = [...this.state.gData];
        let data = this.state.treeData;

        // Find dragObject
        let dragObj;
        loop(data, dragKey, (item, index, arr) => {
            arr.splice(index, 1);
            dragObj = item;
        });

        if (!info.dropToGap) {
            // Drop on the content
            loop(data, dropKey, item => {
                item.cldSet = item.cldSet || [];
                // where to insert 示例添加到尾部，可以是随意位置
                item.cldSet.push(dragObj);
            });
        } else if (
            (info.node.props.cldSet || []).length > 0 && // Has children
            info.node.props.expanded && // Is expanded
            dropPosition === 1 // On the bottom gap
        ) {
            loop(data, dropKey, item => {
                item.cldSet = item.cldSet || [];
                // where to insert 示例添加到头部，可以是随意位置
                item.cldSet.unshift(dragObj);
            });
        } else {
            let ar;
            let i;
            loop(data, dropKey, (item, index, arr) => {
                ar = arr;
                i = index;
            });
            if (dropPosition === -1) {
                ar.splice(i, 0, dragObj);
            } else {
                ar.splice(i + 1, 0, dragObj);
            }
        }

        this.setState({});
    };

    // renderTreeNodes = (data) => {
    //     return data.map((item) => {
    //         if (item.cldSet) {
    //             return (
    //                 <TreeNode title={item.te} key={item._key} dataRef={item}>
    //                     {this.renderTreeNodes(item.cldSet)}
    //                 </TreeNode>
    //             );
    //         }
    //         return <TreeNode title={item.te} key={item._key} dataRef={item} />;
    //     });
    // }
    renderSelectOptions(data) {
        return data.map((item) => {
            return <Option value={item.c}>{item.te}</Option>;
        });
    }

    getCtlProps() {
        // switch (this.state.values.desId) {
        //     case "EP_EO_UI_3101"://文本框
        //         return (getTextEidtor(this));
        //     case "EP_EO_UI_3104"://数字控件
        //         return (getNumberEidtor(this));
        //     case "EP_EO_UI_3105"://时间控件
        //         return (getTimeEidtor(this));
        //     case "EP_EO_UI_3106"://日期控件
        //         return (getDateEidtor(this));
        //     case "EP_EO_UI_3107"://下拉窗控件
        //         return (getComboxEidtor(this));
        //     case "EP_EO_UI_3108"://复选框组件
        //     case "EP_EO_UI_3109"://单选框组件
        //         return (getCheckboxGroupEidtor(this));
        //     case "EP_EO_UI_3110"://复选框控件
        //         return (getCheckboxEidtor(this));
        //     case "EP_EO_NUI_0001"://下拉树控件
        //         return (getComboxTreeEidtor(this));
        //     default:
        //         return (getValidForm(this));
        // }
        // switch (this.state.values.desId) {
        //     case "EP_EO_UI_3101": return getEidtorFun(this, "TextEidtor");//文本框
        //     case "EP_EO_UI_3104": return getEidtorFun(this, "NumberEidtor");//数字控件
        //     case "EP_EO_UI_3105": return getEidtorFun(this, "TimeEidtor");//时间控件
        //     case "EP_EO_UI_3106": return getEidtorFun(this, "DateEidtor");//日期控件
        //     case "EP_EO_UI_3107": return getEidtorFun(this, "ComboxEidtor");//下拉窗控件
        //     case "EP_EO_UI_3108": //复选框组件
        //     case "EP_EO_UI_3109": return getEidtorFun(this, "CheckboxGroupEidtor");//单选框组件
        //     case "EP_EO_UI_3110": return getEidtorFun(this, "CheckboxEidtor");//复选框控件
        //     case "EP_EO_NUI_0001": return getEidtorFun(this, "ComboxTreeEidtor");//下拉树控件
        //     default: return getValidForm(this);
        // }
        return getEidtorFun(this, this.state.values.desId);
    }

    onSelect = (selectedKeys, info) => {
        this.setState({ selectedKeys });
        let record = info.node.props.dataRef;
        this.setState({ values: record });
        let nodeType = record.nodeType;
        this.setState({ nodeType });

        this.setState({ treeNode: info.node });
    }

    addCldSet = (record, nodeType) => {
        let cldSet = record.cldSet;
        if (!cldSet) {
            cldSet = record.cldSet = [];
        }
        let item = {
            te: "xxx",
            _key: uuid(8),
            nodeType: nodeType,
            sc: uuid(8)
        };
        if (nodeType == "tag") {
            item.id = uuid(64);
            item.desId = "EP_EO_UI_3101";//默认文本框
            delete item.sc;
        }
        cldSet.push(item);
        this.setState({ loading: false });
    }

    fitSysCombox() {

        // 下拉窗列表值在标准代码中的id
        var comboBoxData = StandardCode.getSC(custGroupConfig.prmSystemPrm);
        if (!comboBoxData) {
            return;
        }

        let attKey = 'c', attName = 'te';

        this.state.sysStore = [];

        var size = comboBoxData.length;
        if (!size == 0) {
            for (let i = 0; i < size; i++) {
                var item = comboBoxData[i];
                this.state.sysStore.push(<Option value={item[attKey]}>{item[attName]}</Option>);
            }
        }
    }

    getShowCard = () => {

        this.fitSysCombox();

        switch (this.state.nodeType) {
            case "prm":
                return (
                    <Card size="small" title="参数定义">
                        <div style={testStyle} >
                            <Form>
                                {/* <Row>
                                    <Col span={8}>
                                        <FormItem {...formItemLayout} label={"应用编码"}>
                                            <Input disabled={true} value={this.state.values.ap} />
                                        </FormItem>
                                    </Col>
                                    <Col span={8}>
                                        <FormItem {...formItemLayout} label={"系统代码"}>
                                            <Input disabled={true} value={this.state.values.tt} />
                                        </FormItem>
                                    </Col>
                                </Row> */}
                                <Row>
                                    <Col span={8}>
                                        <FormItem {...formItemLayout} label={"子系统编码"}>
                                            <Select value={this.state.values.ss} onChange={selectOnChange.bind(this, this, 'ss')}>{this.state.sysStore}</Select>
                                        </FormItem>
                                    </Col>
                                    <Col span={8}>
                                        <FormItem {...formItemLayout} label={"语义码"}>
                                            <Input value={this.state.values.sc} onChange={textOnChange.bind(this, this, 'sc')} />
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={8}>
                                        <FormItem {...formItemLayout} label={"名称"}>
                                            <Input value={this.state.values.n} onChange={textOnChange.bind(this, this, 'n')} />
                                        </FormItem>
                                    </Col>
                                    <Col span={8}>
                                        <FormItem {...formItemLayout} label={"显示名称"}>
                                            <Input value={this.state.values.te} onChange={textOnChange.bind(this, this, 'te')} />
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={8}>
                                        <FormItem {...formItemLayout} label={"创建人"}>
                                            <Input disabled={true} value={this.state.values.auth} />
                                        </FormItem>
                                    </Col>
                                    <Col span={8}>
                                        <FormItem {...formItemLayout} label={"创建时间"}>
                                            <Input disabled={true} value={this.state.values.crtTm} />
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={8}>
                                        <FormItem {...formItemLayout} label={"修改人"}>
                                            <Input disabled={true} value={this.state.values.edAuth} />
                                        </FormItem>
                                    </Col>
                                    <Col span={8}>
                                        <FormItem {...formItemLayout} label={"修改时间"}>
                                            <Input disabled={true} value={this.state.values.edTm} />
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={8}>
                                        <FormItem {...formItemLayout} label={"参数版本"}>
                                            <Input disabled={true} value={this.state.values.prmVsn} />
                                        </FormItem>
                                    </Col>
                                    <Col span={8}>
                                        <FormItem {...formItemLayout} label={"GUID"}>
                                            <Input disabled={true} value={this.state.values.guid} />
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={16}>
                                        <FormItem {...formItemLayout2} label={"注释"}>
                                            <Input.TextArea value={this.state.values.ann} onChange={textOnChange.bind(this, this, 'ann')} />
                                        </FormItem>
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                    </Card>
                );
            case "group":
                return (
                    <Card size="small" title="分组定义">
                        <div style={testStyle} >
                            <Form>
                                <Row>
                                    <Col span={8}>
                                        <FormItem {...formItemLayout} label={"组名"}>
                                            <Input value={this.state.values.te} onChange={textOnChange.bind(this, this, 'te')} />
                                        </FormItem>
                                    </Col>
                                    <Col span={8}>
                                        <FormItem {...formItemLayout} label={"编码"}>
                                            <Input disabled={true} value={this.state.values.sc ? this.state.values.sc : (this.state.values.sc = tool.uuid(8))} />
                                        </FormItem>
                                    </Col>
                                    <Col span={8}>
                                        <FormItem {...formItemLayout} label={"列表展示"}>
                                            <Checkbox checked={this.state.values.isList} onChange={checkOnChange.bind(this, this, 'isList')} />
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={16}>
                                        <FormItem {...formItemLayout2} label={"描述"}>
                                            <Input.TextArea value={this.state.values.ann} onChange={textOnChange.bind(this, this, 'ann')} />
                                        </FormItem>
                                    </Col>
                                    {this.state.values.isList
                                        ? <Col span={7} offset={1}><span style={{ color: "#faad14" }}>注：列表形式匹配类型只能是“等于”</span></Col>
                                        : null}
                                </Row>
                            </Form>
                        </div>
                    </Card>
                );
            default:
                let desId = this.state.values.desId;
                if (!desId) desId = this.state.values.desId = "EP_EO_UI_3101";
                return (
                    <Card size="small" title="属性定义">
                        <div style={{ ...testStyle, display: this.state.display }} >
                            <Form>
                                <Row>
                                    <Col span={16}>
                                        <FormItem {...formItemLayout2} label={"标签ID"}>
                                            <Input disabled={true} value={this.state.values.id} />
                                        </FormItem>
                                    </Col>
                                    <Col span={3}>
                                        <FormItem style={{ margin: 0 }} labelCol={{ span: 18 }} label={"允许为空"}>
                                            <Checkbox checked={this.state.values.alwBlk} onChange={checkOnChange.bind(this, this, 'alwBlk')} />
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={8}>
                                        <FormItem {...formItemLayout} label={"名称"}>
                                            <Input value={this.state.values.te} onChange={textOnChange.bind(this, this, 'te')} />
                                        </FormItem>
                                    </Col>
                                    <Col span={8}>
                                        <FormItem {...formItemLayout} label={"编码"}>
                                            <Input value={this.state.values.c} onChange={textOnChange.bind(this, this, 'c')} />
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={16}>
                                        <FormItem {...formItemLayout2} label={"描述"}>
                                            <Input value={this.state.values.ann} onChange={textOnChange.bind(this, this, 'ann')} />
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={8}>
                                        <FormItem {...formItemLayout} label={"组件类型"}>
                                            <Select
                                                value={desId}
                                                onChange={selectOnChange.bind(this, this, "desId")}>
                                                {this.renderSelectOptions(ctlTypes)}
                                            </Select>
                                        </FormItem>
                                    </Col>
                                    <Col span={8}>
                                        <FormItem {...formItemLayout} label={"值类型"}>
                                            <Select
                                                value={this.state.values.valueType || "01"}
                                                onChange={selectOnChange.bind(this, this, "valueType")}>
                                                {this.renderSelectOptions(valueTypes)}
                                            </Select>
                                        </FormItem>
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                        <div style={testStyle}>
                            {this.getCtlProps()}
                        </div>
                        <Card size="small" title="列表属性(当分组节点为列表展示时，以下属性有效)" bordered={false}>
                            <Form>
                                <Row>
                                    <Col span={8}>
                                        <FormItem {...formItemLayout} label={"列宽"}>
                                            <Input value={this.state.values.width} onChange={textOnChange.bind(this, this, 'width')} />
                                        </FormItem>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </Card>
                );
        }

    }

    render() {
        let nodeType = this.state.nodeType;
        let groupFlg = nodeType === "prm" || nodeType === "group" || nodeType === "";
        let tagFlg = nodeType === "group";
        let copyFlg = nodeType !== "prm";
        let deleteFlg = nodeType === "group" || nodeType === "tag" || nodeType === "item";
        return (
            <div style={{ height: '100%', width: '100%', padding: 5 }}>
                <Row style={{ margin: '5px 0px 5px 0px', height: "100%" }}>
                    <Col span={5} style={{ height: "100%", overflow: "auto" }}>
                        <div style={{ ...testStyle }}>
                            <Tree
                                draggable
                                defaultExpandAll
                                onSelect={this.onSelect}
                                selectedKeys={this.state.selectedKeys}
                                blockNode
                                onDrop={this.onDrop}
                            >
                                {renderTreeNodes(this.state.treeData)}
                            </Tree>
                        </div>
                    </Col>
                    <Col span={19} style={{ height: "100%", overflow: "auto", display: "flex", flexDirection: "column" }}>
                        <div style={{ ...testStyle }}>
                            <Button type="primary" onClick={this.save} style={{ margin: 5 }} >保存</Button>
                            <Button disabled={!groupFlg} onClick={this.addSub.bind(this, "group")} style={{ margin: "5px 5px 5px 0" }} >添加分组</Button>
                            <Button disabled={!tagFlg} onClick={this.addSub.bind(this, "tag")} style={{ margin: "5px 5px 5px 0" }} >添加指标</Button>
                            <Button disabled={!copyFlg} onClick={this.copyNode} style={{ margin: "5px 5px 5px 0" }} >复制节点</Button>
                            <Button disabled={!deleteFlg} onClick={this.delNode} style={{ margin: "5px 5px 5px 0" }} >{`删除${nodeType === "group" ? "分组" : "指标"}`}</Button>
                        </div>
                        {this.getShowCard()}
                    </Col>
                </Row>
                {getSCModal(this)}
            </div >
        )
    }

}

export default ParamMngPrmDef;



// WEBPACK FOOTER //
// ./apps/pages/paramMng/ParamMngPrmDef.js